import {Link} from "react-router-dom";
import mobileLogo from "../assets/thrombiocolourlogocopy4.webp";

export default function Footer() {
    return (
        <div className="max-w-dvw z-10">
      <div className="page-width flex justify-center pb-20 md:py-16">
        <Link to="/" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}><img src={mobileLogo} alt="ThromBio Logo" className="max-lg:max-h-[66px]" /></Link>
      </div>
    </div>
  );
}
